import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PrivateRoute from "../private-route";

import Location from "./location";
import Project from "./project";
import Dashboard from "./dashboard";

import Methodology from "./methodology";
import TransitionRisk from "./transitionrisk";

import TransitionAnalysis from "./transition_analysis";
import EditTransition from "./edit_transition";
import Realestate from "./realestate";
import RealEstateDashboard from "./realestate_dashboard";

import Toolkit from "./adaptation_tookit";
import ChangelogPage from "./changelog";
import DistrictMap from "./district_map";
import FAQSearchPage from "./faq";

import CreateMap from "./map_create";
import DownloadMap from "./download_map";
import SidebarLayout from "./sidebar";
import Setup from "./setup";

class AppLayout extends Component {
  constructor() {
    super();
    this.state = {
      collapsed: false,
      tierdata: null,
    };
  }
  handleSidebarCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  componentDidMount() {
    this.loadTierData();

    // Listen for custom event to refresh tierdata when updated
    window.addEventListener("tierDataUpdated", this.loadTierData);

    // Add event listener for back button click
    window.addEventListener("popstate", this.handleBackButton);
  }

  loadTierData = () => {
    const storedTierData = localStorage.getItem("tier_data");
    if (storedTierData) {
      try {
        const parsed = JSON.parse(storedTierData);
        this.setState({ tierdata: parsed });
      } catch (e) {
        console.error("Invalid tierdata in localStorage", e);
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener("tierDataUpdated", this.loadTierData);
    window.removeEventListener("popstate", this.handleBackButton);
  }

  handleBackButton = () => {
    // Handle back button click if needed
    // For example, you can prevent default behavior or perform custom actions
  };
  render() {
    const { containerClassnames } = this.props;
    const { collapsed, tierdata } = this.state;

    const isMapAllowed =
      tierdata?.allowed_modules &&
      Array.isArray(tierdata.allowed_modules) &&
      tierdata.allowed_modules.includes("map");

    console.log("map tier", isMapAllowed);

    /*if (auth.isUserAuthenticated()) {
      if (localStorage.getItem("theme") == "dark") {
        import("../css/sass/themes/gogo.light.purple.scss").then(() => {});
      } else {
        import("../css/sass/themes/gogo.light.purple.scss").then(() => {});
      }
    }*/
    return (
      <div style={{ display: "flex" }}>
        <SidebarLayout onCollapse={this.handleSidebarCollapse} />
        {/*<TopNavbar />*/}

        <div
          id="container-fluid"
          className={collapsed ? "collapsed" : "expanded"}
          style={{
            //marginTop: "1%",
            flex: 1,
            marginLeft: collapsed ? "102px" : "285px",
            //transition: "margin-left 0.2s",
          }}
        >
          <PrivateRoute path="/location" component={Location} />
          <PrivateRoute path="/realestate" component={Realestate} />
          <PrivateRoute path="/project" component={Project} />
          <PrivateRoute path="/dashboard" component={Dashboard} />
          <PrivateRoute path="/transition" component={TransitionRisk} />
          <PrivateRoute path="/toolkit" component={Toolkit} />
          <PrivateRoute path="/changelog" component={ChangelogPage} />
          <PrivateRoute path="/faq" component={FAQSearchPage} />
          <PrivateRoute
            path="/realestate-dashboard"
            component={RealEstateDashboard}
          />

          {/*<PrivateRoute path="/report" component={Export} />*/}
          {/* <PrivateRoute path="/hazard" component={HazardDashboard} />*/}
          {/*<PrivateRoute path="/invoice" component={Invoice} />*/}
          {/*<PrivateRoute path="/tcfd" component={TCFD} />*/}
          {/*<PrivateRoute path="/detailreport" component={DetailedReport} />*/}
          <PrivateRoute path="/methodology" component={Methodology} />
          {/*<PrivateRoute path="/pivottable" component={Application} />*/}

          {/* <PrivateRoute path="/create-transition" component={TransitionRisk} />*/}
          <PrivateRoute
            path="/transition-analysis"
            component={TransitionAnalysis}
          />
          <PrivateRoute path="/edit-transition" component={EditTransition} />
          <PrivateRoute path="/map" component={DownloadMap} />
          <PrivateRoute path="/create-map" component={CreateMap} />
          <PrivateRoute path="/setup" component={Setup} />
          <PrivateRoute path="/district" component={DistrictMap} />
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ menu }) => {
  const { containerClassnames } = menu;
  return { containerClassnames };
};
const mapActionToProps = {};

export default withRouter(
  connect(mapStateToProps, mapActionToProps)(AppLayout)
);
